<template>
    <v-tab-item :value="$route.fullPath" class="pa-3">
        <v-toolbar flat height="90">
            <v-spacer></v-spacer>

            <v-col cols="12" sm="4">
                <b-search-field></b-search-field>
            </v-col>
        </v-toolbar>

        <v-data-table
            :headers="headers"
            :items="multipleCoupons"
            :footer-props="{
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= serverItemsLength
                        ? page * 12
                        : serverItemsLength
                } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :server-items-length="serverItemsLength"
            :loading="loading"
            class="b-outlined"
        >
        </v-data-table>
    </v-tab-item>
</template>

<script>
import multipleCoupons from "@/store/modules/storePanel/redeem/multipleCoupons";

import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/storePanel/couponsOverview";

export default {
    name: "MultipleCoupons",

    mixins: [translations],

    data() {
        return {
            page: +this.$route.query.page,
        };
    },

    computed: {
        ...mapState(["loading", "serverItemsLength", "superUser"]),
        ...mapState("storePanel/multipleCoupons", ["multipleCoupons"]),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return this.$store.state.permissions.redemption
                ? this.$store.state.permissions.redemption.multiple_coupons
                : this.superUser;
        },

        headers() {
            return [
                {
                    text: this.translations.value[this.lang],
                    value: "price",
                },
                // { text: this.translations.points[this.lang], value: "points" },
                {
                    text: this.translations.timestamp[this.lang],
                    value: "redeemed_at",
                },
                {
                    text: this.translations.voucherCode[this.lang],
                    value: "voucher",
                },
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapActions("storePanel/multipleCoupons", ["getItems"]),
    },

    watch: {
        permission: {
            immediate: true,
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/storePanel/forbidden-gateway`
                    );
                }
            },
        },

        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getItems(this.query);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },
    },

    beforeCreate() {
        if (!this.$store.state.storePanel.multipleCoupons) {
            this.$store.registerModule(
                ["storePanel", "multipleCoupons"],
                multipleCoupons
            );
        }

        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },

    mounted() {
        this.getItems(this.query);
    },
};
</script>
